import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  move: {
    id: 'move',
    defaultMessage: 'Move',
  },
  copy: {
    id: 'copy',
    defaultMessage: 'Copy',
  },
  moveActors: {
    id: 'moveActors',
    defaultMessage: 'Move actors to layer',
  },
  copyActors: {
    id: 'copyActors',
    defaultMessage: 'Copy actors to layer',
  },
  moveToNewLayer: {
    id: 'moveToNewLayer',
    defaultMessage: 'Create new layer',
  },
  selectExistLayer: {
    id: 'selectExistLayer',
    defaultMessage: 'Select existing layer',
  },
  searchTargetLayer: {
    id: 'searchTargetLayer',
    defaultMessage: 'Search layer by name',
  },
  searchTargetNoRes: {
    id: 'searchTargetNoRes',
    defaultMessage: 'There are no results for your search request',
  },
  moveSuccessfully: {
    id: 'moveSuccessfully',
    defaultMessage: 'Actors were moved successfully',
  },
  copySuccessfully: {
    id: 'copySuccessfully',
    defaultMessage: 'Actors were copied successfully',
  },
  moveLoop: {
    id: 'moveLoop',
    defaultMessage: 'Unable to move or copy actors with a loop on a tree layer',
  },
});

export default { ...globalIntl, ...m };
